module.exports = __webpack_public_path__ + "/7e079521f59191633b3f7f14fc7ca4a3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/slack_logo.svg
 ** module id = 1636
 ** module chunks = 0
 **/